module.exports = __webpack_public_path__ + "static/media/gift-to-from-sticker.bf20e7ca.png";